import React from 'react'
import { FaBug as VirusIcon } from '@react-icons/all-files/fa/FaBug'
import { FaRegFile as UnknownFileIcon } from '@react-icons/all-files/fa/FaRegFile'
import { FaRegFileAlt as TextIcon } from '@react-icons/all-files/fa/FaRegFileAlt'
import { FaRegFileExcel as ExcelIcon } from '@react-icons/all-files/fa/FaRegFileExcel'
import { FaRegFileImage as ImageIcon } from '@react-icons/all-files/fa/FaRegFileImage'
import { FaRegFilePdf as PdfIcon } from '@react-icons/all-files/fa/FaRegFilePdf'
import {
  IMAGE_FILE,
  PDF_FILE,
  SPREADSHEET_FILE,
  TEXT_FILE,
  UNKNOWN_FILE,
} from '@disco/constants/FileTypes'
import Icon from 'components/ui/icon'
const ICONS = {
  [IMAGE_FILE]: ImageIcon,
  [PDF_FILE]: PdfIcon,
  [SPREADSHEET_FILE]: ExcelIcon,
  [TEXT_FILE]: TextIcon,
  [UNKNOWN_FILE]: UnknownFileIcon,
}

const getIconSize = (base: number, size: Props['size']) => {
  let multiplier = 1

  if (size === 'large') {
    multiplier = 4
  }

  return {
    size: base * multiplier,
  }
}

type Props = {
  fileType: string
  size?: 'small' | 'large'
  virus?: boolean
}

const FileIcon = ({
  fileType,
  size = 'small',
  virus,
}: Props): React.ReactNode => {
  const FileTypeIcon = ICONS[fileType]

  if (virus) {
    return <VirusIcon {...getIconSize(20, size)} />
  }

  if (fileType === 'folder') {
    return <Icon type="folder" {...getIconSize(24, size)} />
  }

  if (FileTypeIcon) {
    return <FileTypeIcon {...getIconSize(20, size)} />
  }

  return <Icon type="soundwave" {...getIconSize(24, size)} />
}

export default FileIcon
